
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';
import PlatformFeedbackForm from './PlatformFeedbackForm';

interface FeedbackButtonProps {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
}

const FeedbackButton = ({ 
  variant = 'outline', 
  size = 'sm', 
  className = '' 
}: FeedbackButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setIsOpen(true)}
        className={className}
      >
        <MessageSquare className="h-4 w-4 mr-2" />
        Visszajelzés
      </Button>
      
      <PlatformFeedbackForm
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default FeedbackButton;
